import Vue from 'vue'
import iView from 'iview'
import ElementUI from 'element-ui';
import store from "./store";
import App from './app.vue'
import { appRouter } from '@/router/router'
import router from '@/router/index'
import $axios from '@/tool/axios.js'
import Directives from '@/directives/index'
import dataV from '@jiaminghi/data-view'
import 'iview/dist/styles/iview.css'
import 'element-ui/lib/theme-chalk/index.css';
import 'bulma/css/bulma.css'
import '@/styles/css/common.css'
import '@/styles/css/normalize.css'
import compnents from '@/common/index';
import '@/style/iconfont.css'
import tools from '@/tool/tools'
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'
import '@/icon-styles/style.css'
import VueDragResize from 'vue-drag-resize'
const multiConfig = require('../../config/multi.conf')

import VueDND from 'awe-dnd'
Vue.config.productionTip = false;

Vue.prototype.$CustomFile = (fileBits, fileName, opts) => {
    return new File(fileBits, fileName, opts)
}

// console.log(File)
// window.CustomFile = CustomFile
// window.newFileFunc = function (arr, name, type) { 
//     return new File(arr, name, type)
// }

// document.addEventListener('touchmove',function(ev){
//   ev.preventDefault();
// },{passive:false});

(function () {
    if (typeof WeixinJSBridge == "object" && typeof WeixinJSBridge.invoke == "function") {
        handleFontSize();
    } else {
        if (document.addEventListener) {
            document.addEventListener("WeixinJSBridgeReady", handleFontSize, false);
        } else if (document.attachEvent) {
            document.attachEvent("WeixinJSBridgeReady", handleFontSize);
            document.attachEvent("onWeixinJSBridgeReady", handleFontSize);
        }
    }
    
    function handleFontSize() {
        // 设置网页字体为默认大小
        WeixinJSBridge.invoke('setFontSizeCallback', {
            'fontSize': 0
        });
        // 重写设置网页字体大小的事件
        WeixinJSBridge.on('menu:setfont', function () {
            WeixinJSBridge.invoke('setFontSizeCallback', {
            'fontSize': 0
            });
        });
    }
})();

// 设置 rem 函数
function setRem () {
  // 320 默认大小16px; 320px = 20rem ;每个元素px基础上/16
  let htmlWidth = document.documentElement.clientWidth || document.body.clientWidth;
  let htmlHeight = document.documentElement.clientHeight || document.body.clientHeight;
  console.log('htmlHeight',htmlHeight);
  //得到html的Dom元素
  let htmlDom = document.getElementsByTagName('html')[0];
  const userAgent = navigator.userAgent
  let isMobileApp = /Android|iPhone/.test(userAgent)
    //设置根元素字体大小
    if (isMobileApp && htmlWidth <= 480) {
        htmlDom.style.fontSize = htmlWidth / (375 / 16) + 'px';
    } else { 
        htmlDom.style.fontSize = htmlHeight / (1080 / 16) + 'px';
    }
}
setRem();
// 改变窗口大小时重新设置 rem
window.addEventListener('resize', function () {
  setRem()
})

const ua = window.navigator.userAgent
if (/Android|iPhone/.test(ua)) {
    var meta = document.createElement('meta');
    meta.setAttribute('name', 'viewport');
    meta.setAttribute('content', 'initial-scale=1.0, maximum-scale=1.0, user-scalable=no,viewport-fit=cover');
    document.head.appendChild(meta);

    // 创建 <style> 元素
    var style = document.createElement('style');
    style.setAttribute('type', 'text/css')
    
    // 设置 CSS 样式
    style.innerHTML = '.v-modal { display: none!important;} .el-drawer__container { background: rgba(0,0,0,0.5) }'; // 这里只是举例，可根据需要自行更改样式规则
    
    // 将 <style> 元素添加到页面头部（head）
    document.getElementsByTagName('head')[0].appendChild(style);

    // document.getElementsByClassName('v-modal')[0].style.display = 'none'

    // const ua = navigator.userAgent;
    // const iOS = /iPad|iPhone|iPod/.test(ua);
    // const input = document.querySelector('#input');

    // input.addEventListener('focus', () => {
    //     setTimeout(() => {
    //         if (iOS) {
    //             if (!/OS 11_[0-3]\D/.test(ua)) {
    //                 document.body.scrollTop = document.body.scrollHeight;   
    //             }
    //         } else {
    //             input.scrollIntoView(false);
    //         }
    //     }, 300);
    // });

}

document.getElementsByTagName('html')[0].style.height = '100%'
document.body.style.overflow = 'hidden'
document.body.style.width = '100%'
document.body.style.height = '100%'
document.body.style.background = '#fff'

// Vue.use(preview)
Vue.use(iView);
Vue.use(ElementUI,{ zIndex: 1400 });
Vue.use(VueDND)
Vue.use(Directives)
Vue.use(dataV)
Vue.use(VueViewer)
Vue.prototype.$tools = tools;
Vue.prototype.$axios = $axios;
Vue.component('vue-drag-resize', VueDragResize)

router.beforeEach(function(to, from, next) {
    let cachePage = JSON.parse(localStorage.cachePage || '[]');
    cachePage = [...new Set([to.name, ...cachePage])];
    localStorage.cachePage = JSON.stringify(cachePage);
    store.commit('initCachepage');
    next();
});

new Vue({
    router: router,
    store,
    render: h => h(App),
    data: {
        currentPageName: ''
    },
    mounted() {
        this.currentPageName = this.$route.name;
        this.$store.commit('initCachepage');
        // 权限菜单过滤相关
        this.$store.commit('updateMenulist');
        // 全屏相关
        document.addEventListener('fullscreenchange', () => {
            this.$store.commit('changeFullScreenState');
        });
        document.addEventListener('mozfullscreenchange', () => {
            this.$store.commit('changeFullScreenState');
        });
        document.addEventListener('webkitfullscreenchange', () => {
            this.$store.commit('changeFullScreenState');
        });
        document.addEventListener('msfullscreenchange', () => {
            this.$store.commit('changeFullScreenState');
        });
    },
    created() {
        if (process.env.NODE_ENV !== 'development' && location.href.indexOf('aibeings.yf-gz.cn') < 0) {
            this.$store.state.uploadUrl = '/digitalHuman/aichat/api/upload/unCheck'
        }
        //拿到项目配置（包括代理路径，获取本地环境连接的是测试服还是正式服）
        let dhMultiConfig = multiConfig.process2('digitalHuman')
        if(process.env.NODE_ENV !== 'development' && location.href.indexOf('aibeings.yf-gz.cn') > -1) {
            this.$store.state.env = 'prod'
        }
        if(process.env.NODE_ENV == 'development' && dhMultiConfig.proxyTable['/api'].target.indexOf('aibeings.yf-gz.cn') > -1) {
            this.$store.state.env = 'prod'
        }
        const userAgent = navigator.userAgent
        let isMobileApp = /Android|iPhone/.test(userAgent)
        //移动端
        if(isMobileApp) {
            this.$store.state.isMobileApp = true
        }
        let tagsList = [];
        appRouter.map((item) => {
            if (item.children.length <= 1) {
                tagsList.push(item.children[0]);
            } else {
                tagsList.push(...item.children);
            }
        });
        this.$store.commit('setTagsList', tagsList);
    }
}).$mount('#app')


// WEBPACK FOOTER //
// ./src/digitalHuman/main.js